import * as ActionKeys from './ActionKeys';
import { initialState } from './InitialState';
import { Generic, IAction, States } from '../interfaces/interfaces';

export const reducer = (state: States, action: IAction) => {
    switch (action.type) {
        case ActionKeys.SET_ACTIVE_PAGE:
            return {
                ...state,
                activePage: action.payload
            };
        case ActionKeys.SET_ERROR:
            return {
                ...state,
                error: {
                    ...state.error,
                    hasError: !!(action.payload as Generic<boolean>).hasError,
                    redirectToPage: (action.payload as Generic<string | undefined>).redirectToPage
                        ? (action.payload as Generic<string | undefined>).redirectToPage
                        : undefined,
                    errorMessage: (action.payload as Generic<string>).errorMessage,
                    manufacturerDataDeficient: (action.payload as Generic<boolean>).manufacturerDataDeficient,
                    operation: (action.payload as Generic<boolean>).operation
                }
            };
        case ActionKeys.RESET:
            return initialState;
        case ActionKeys.RESET_VEHICLE:
            return {
                ...state,
                selection: {
                    ...state.selection,
                    registrationNumber: '',
                    manufactor: undefined,
                    fuel: undefined,
                    model: undefined,
                    vintage: undefined,
                    motorSize: undefined,
                    power: undefined,
                    variantId: undefined
                },
                fieldValidation: {
                    ...state.fieldValidation,
                    registrationNumber: false
                },
                model: {
                    ...state.model,
                    CAR: {
                        ...state.model.CAR,
                        dmr: null
                    }
                }
            };
        case ActionKeys.RESET_PACKAGE: {
            return {
                ...state,
                selection: {
                    ...state.selection,
                    package: null,
                    deductible: null
                },
                model: {
                    ...state.model,
                    [(action.payload as Generic<string>).productKey]: {
                        ...state.model[(action.payload as Generic<string>).productKey],
                        packages: null
                    }
                }
            };
        }
        case ActionKeys.SET_PURCHASE_COMPLETE:
            return {
                ...state,
                purchaseComplete: action.payload
            };
        case ActionKeys.SET_DID_CLICK_FETCH_PACKAGES:
            return {
                ...state,
                selection: {
                    ...state.selection,
                    didClickFetchPackages: action.payload
                }
            };
        case ActionKeys.SET_SELECTION_VALUE:
            return {
                ...state,
                selection: {
                    ...state.selection,
                    [(action.payload as Generic<string>).key]: (action.payload as Generic<string>).value
                }
            };
        case ActionKeys.SET_SELECTION_VALUES:
            return {
                ...state,
                selection: {
                    ...state.selection,
                    ...(action.payload as Selection)
                }
            };
        case ActionKeys.SET_SELECTION:
            // This will overwrite selection. You probably want SET_SELECTION_VALUE
            return {
                ...state,
                selection: action.payload
            };
        case ActionKeys.SET_MODEL:
            return {
                ...state,
                model: action.payload
            };
        case ActionKeys.SET_DATA_MODEL_VALUE:
            return {
                ...state,
                model: {
                    ...state.model,
                    [(action.payload as Generic<string>).productKey]: {
                        ...state.model[(action.payload as Generic<string>).productKey],
                        [(action.payload as Generic<string>).dataKey]: (action.payload as Generic<string>).value
                    }
                }
            };
        case ActionKeys.SET_DATA_MM_SELECTION:
            return {
                ...state,
                selection: {
                    ...state.selection,
                    manufactor: (action.payload as Generic<string>).manufactor,
                    fuel: (action.payload as Generic<string>).fuel,
                    model: (action.payload as Generic<string>).model,
                    vintage: (action.payload as Generic<string>).year,
                    motorSize: (action.payload as Generic<string>).engine,
                    power: (action.payload as Generic<string>).power,
                    variantId: (action.payload as Generic<string>).variantId,
                    registrationNumber: (action.payload as Generic<string>).registrationNumber,
                    vehicleSelectionMode: (action.payload as Generic<string>).vehicleSelectionMode,
                    eligibleForLeasing: (action.payload as Generic<string>).eligibleForLeasing
                }
            };
        case ActionKeys.SET_DATA_MODEL_MM:
            return {
                ...state,
                model: {
                    ...state.model,
                    CAR: {
                        ...state.model.CAR,
                        manufactors: (action.payload as Generic<string>).manufactors,
                        fuels: (action.payload as Generic<string>).fuels,
                        models: (action.payload as Generic<string>).models,
                        years: (action.payload as Generic<string>).years,
                        engines: (action.payload as Generic<string>).engines,
                        powers: (action.payload as Generic<string>).powers
                    }
                }
            };
        case ActionKeys.SET_FIELD_VALIDATION:
            return {
                ...state,
                fieldValidation: {
                    ...state.fieldValidation,
                    [(action.payload as Generic<string>).fieldKey]: (action.payload as Generic<string>).valid
                }
            };
        case ActionKeys.SET_FIELD_VALIDATIONS:
            return {
                ...state,
                fieldValidation: {
                    ...state.fieldValidation,
                    ...(action.payload as Generic<boolean>)
                }
            };
        case ActionKeys.SET_LABELS:
            return {
                ...state,
                labels: {
                    ...state.labels,
                    [(action.payload as Generic<string>).productKey]: {
                        ...state.labels[(action.payload as Generic<string>).productKey],
                        [(action.payload as Generic<string>).labelKey]: (action.payload as Generic<string>).value
                    }
                }
            };
        case ActionKeys.SET_RELOAD_STAKEHOLDER:
            return {
                ...state,
                reloadStakeholder: action.payload
            };
        case ActionKeys.SET_SHOULD_CHECK_BBR:
            return {
                ...state,
                shouldCheckBBR: action.payload
            };
        case ActionKeys.CLEAR_STORE:
            return initialState;

        default:
            return state;
    }
};
